import { createSharedState } from 'Shared/use-shared-state';

declare const App: {
   isSubscribed: boolean;
};

export const hideSubBoxSlice = createSharedState('hideSubBox', App.isSubscribed);
export const useHideSubBox = hideSubBoxSlice.hook;
